import React from 'react';
import { CheckCircle } from 'lucide-react';
import { mediationProcess } from '../data/content';

const HowItWorks = () => {
  return (
    <div className="min-h-screen bg-white pt-32 pb-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold mb-6" style={{ color: '#5E7F8A' }}>
            How Mediation Works
          </h1>
          <p className="text-xl max-w-3xl mx-auto mb-8" style={{ color: '#5E7F8A' }}>
            A clear, structured process designed to guide you toward peaceful resolution.
          </p>
          <div className="w-24 h-1 mx-auto" style={{ backgroundColor: '#9BB2A2' }}></div>
        </div>

        {/* Hero Image */}
        <div className="mb-16">
          <img 
            src="https://images.unsplash.com/photo-1765737410230-37d844567a85" 
            alt="Peaceful journey"
            className="w-full h-96 object-cover rounded-lg shadow-lg"
          />
        </div>

        {/* Process Steps */}
        <div className="space-y-12">
          {mediationProcess.map((step, index) => (
            <div 
              key={step.step}
              className="relative pl-12"
            >
              {/* Vertical Line (except for last item) */}
              {index !== mediationProcess.length - 1 && (
                <div 
                  className="absolute left-4 top-12 bottom-0 w-0.5"
                  style={{ backgroundColor: '#9BB2A2' }}
                ></div>
              )}

              {/* Step Number Circle */}
              <div 
                className="absolute left-0 top-0 w-9 h-9 rounded-full flex items-center justify-center text-white font-bold shadow-md"
                style={{ backgroundColor: '#9BB2A2' }}
              >
                {step.step}
              </div>

              {/* Step Content */}
              <div className="bg-white rounded-lg p-8 shadow-md hover:shadow-lg transition-shadow">
                <h3 className="text-2xl font-semibold mb-4" style={{ color: '#5E7F8A' }}>
                  {step.title}
                </h3>
                <p className="text-base leading-relaxed" style={{ color: '#5E7F8A' }}>
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Benefits Section */}
        <div className="mt-20">
          <div className="rounded-lg p-10 text-white mb-8" style={{ backgroundColor: '#5E7F8A' }}>
            <h2 className="text-3xl font-bold text-center">Benefits of Our Process</h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {[
              "Flexible scheduling for your convenience",
              "Private and comfortable environment",
              "Reduced stress compared to court proceedings",
              "Cost-effective resolution",
              "Control over your own agreements",
              "Child-centered decision making"
            ].map((benefit, index) => (
              <div key={index} className="flex items-start space-x-3">
                <CheckCircle size={24} style={{ color: '#9BB2A2' }} className="flex-shrink-0 mt-0.5" />
                <p className="text-lg" style={{ color: '#5E7F8A' }}>
                  {benefit}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
